import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Placeholder from "@/pages/Placeholder";
import Founders from "@/pages/Founders";
import Businesses from "@/pages/Businesses";
import Nonprofits from "@/pages/Nonprofits";
import Services from "@/pages/Services";
import Workshops from "@/pages/Workshops";
import Contact from "@/pages/Contact";
import OS from "@/pages/OS";
import AdminLeads from "@/pages/AdminLeads";
import HowItWorks from "@/pages/HowItWorks";

const FUTURE_PAGES = [
  { path: "/founder-os", title: "Founder OS" },
  { path: "/business-os", title: "Business OS" },
  { path: "/nonprofit-os", title: "Nonprofit OS" },
  { path: "/about", title: "About" },
];

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView(), 150);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function Grain() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-[60] opacity-[0.05] mix-blend-multiply"
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='140' height='140' filter='url(%23n)'/%3E%3C/svg%3E\")",
      }}
    />
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <ScrollToTop />
          <Grain />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/founders" element={<Founders />} />
            <Route path="/businesses" element={<Businesses />} />
            <Route path="/nonprofits" element={<Nonprofits />} />
            <Route path="/services" element={<Services />} />
            <Route path="/workshops" element={<Workshops />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/os" element={<OS />} />
            <Route path="/admin" element={<AdminLeads />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            {FUTURE_PAGES.map((p) => (
              <Route
                key={p.path}
                path={p.path}
                element={<Placeholder title={p.title} />}
              />
            ))}
            <Route path="*" element={<Placeholder title="Page not found" />} />
          </Routes>
          <Footer />
        </ReactLenis>
      </BrowserRouter>
    </div>
  );
}

export default App;
